export enum FinalStepsFormField {
  PENDING_REQUIRED_DOCUMENTATION = 'pendingRequiredDocumentation',
  INTERNAL_NOTES = 'internalNotes'
}
